import React, { CSSProperties } from 'react';

import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { withSelector } from '../../../../shared/withSelector.js';
import { ISummaryBlockProps } from '../../SummaryBlock/models/index.js';
import SummaryBlock from '../../SummaryBlock/SummaryBlock.js';
import { SUMMARY_BLOCKS_CATEGORY_KEY, SUMMARY_BLOCKS_COMPONENT_KEY } from '../SummaryBlocks.meta.js';

// eslint-disable-next-line @typescript-eslint/naming-convention
const Block = (props: ISummaryBlockProps) => {
	const { className, weight, basis, ...blockProps } = props;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	const Section: any = withSelector('section' as any, props);
	const style: CSSProperties = { flex: 'auto' };
	if (weight) {
		style.flexGrow = weight;
	}
	if (basis) {
		style.flexBasis = basis;
	}

	return (
		<Section className={className} style={style}>
			<SummaryBlock {...blockProps} />
		</Section>
	);
};

export default InjectedStyledComponent(Block, SUMMARY_BLOCKS_CATEGORY_KEY, SUMMARY_BLOCKS_COMPONENT_KEY, ['block']);
